import styled, { css } from "styled-components";

import { COLOR } from "@sellernote/ui/src/sds-v1/styles/constants";
import { setFontStyle } from "@sellernote/ui/src/sds-v1/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

const container = styled.div`
  display: flex;
  justify-content: center;

  nav {
    width: 997px;
    padding: 20px 0;

    ${mobile(css`
      width: 100%;
      padding: 0;
      overflow: hidden;
    `)}
  }

  nav > ol {
    display: flex;
    align-items: center;
    list-style-type: none;
    padding-left: 0;
  }

  nav * {
    word-break: keep-all;
  }
`;

const breadcrumb = styled.li<{ isRecentDepth?: boolean }>`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  color: ${COLOR.secondaryDeepPurple};

  a {
    color: ${COLOR.secondaryDeepPurple};
  }

  ${(props) =>
    props.isRecentDepth
      ? setFontStyle("SubHead3", "Bold")
      : setFontStyle("SubHead3")};

  .breadcrumb-title {
    display: block;
    padding: 8px;
  }

  &::after {
    display: inline-block;
    color: ${COLOR.secondaryDeepPurple_40};
    content: "/";
    ${setFontStyle("SubHead3")};
    padding: 8px;
  }

  &:last-child > a > .breadcrumb-title {
    max-width: 350px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    ${mobile(css`
      max-width: 130px;
    `)}
  }

  &:last-child::after {
    display: none;
  }
`;

export default {
  container,
  breadcrumb,
};
